/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { gettingStartedQueueEditEntryPoint } from '@jira/spa-apps__servicedesk-getting-started-page/src/gettingStartedQueueEditEntryPoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { QueueSettingsSkeleton } from '@jira/platform__skeletons/src/ui/getting-started-page/QueueSettingsSkeleton.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
	getQueuesResources,
	getQueueConfigResource,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { getCalendarFilterFieldsResource } from '@jira/router-resources__service-desk-calendar/src/useCalendarFilterResource.tsx';
import { servicedeskIssueTypesResource } from '@jira/router-resources__service-desk-issue-types/src/servicedeskIssueTypesResource.tsx';
import { servicedeskGettingStartedQueueEditRoute } from '@jira/router-routes__servicedesk-getting-started-page-routes/src/servicedeskGettingStartedQueueEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const queueEditPageEntryPoint = createPageEntryPoint({
	main: gettingStartedQueueEditEntryPoint,
});

export const servicedeskGettingStartedQueueEditRouteEntry: Route = createEntry(
	servicedeskGettingStartedQueueEditRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		perfMetricKey: 'servicedesk-getting-started-queue-edit-load',
		skeleton: QueueSettingsSkeleton,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			...getQueuesResources(),
			...getQueueConfigResource(),
			staticProjectSidebarNavigationResource,
			servicedeskIssueTypesResource,
			getConsolidationStateResource(),
			getCalendarFilterFieldsResource(),
		],

		entryPoint() {
			return fg('solution_composer_master') ? queueEditPageEntryPoint : undefined;
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
